import { forwardRef, useEffect } from "react";
import {
  TextField,
  Grid,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  SimCard,
} from "../../../../app/slices/simCardSlice";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  HiOutlineDevicePhoneMobile,
  HiOutlineIdentification,
  HiOutlineCog6Tooth,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  SwitchCard,
} from "../../../../components/FormDialog";

const SimCardForm = () => {
  const _SimCard = useSelector((state) => state.simCard.simCard);
  const _SearchBody = useSelector((state) => state.simCard.searchBody);
  const loading = useSelector((state) => state.simCard.simCard.loading);

  const isAdd = _SimCard.form.id ? false : true;
  const {
    control,
    handleSubmit,
    setValue,
    formState: { isDirty },
  } = useForm({
    defaultValues: _SimCard.form,
  });

  const onSubmit = (data) => {
    data.daily_limit = parseInt(data.daily_limit);
    data.balance = 0;
    if (isAdd) {
      dispatch(SimCard.create(data));
    } else {
      dispatch(SimCard.update(data.id, data, _SearchBody));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  const status = [
    { key: "zain", name: "Zain" },
    { key: "asia", name: "Asia Cell" },
    { key: "korek", name: "Korek" },
  ];

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <FormDialog
      open={_SimCard.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineDevicePhoneMobile />}
      title={isAdd ? "إضافة شريحة" : "معلومات الشريحة"}
      subtitle={
        isAdd
          ? "أدخل معلومات الشريحة لإضافتها"
          : "قم بتحديث معلومات الشريحة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      saveDisabled={!isDirty}
      loading={loading}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="المعلومات الأساسية">
        <Grid item xs={12} sm={6}>
          <Controller
            name="type"
            control={control}
            render={({ field }) => (
              <Autocomplete
                options={status}
                getOptionLabel={(option) => option.name || ""}
                value={status.filter((x) => x.key == field.value)[0]}
                onChange={(e, newValue) => {
                  setValue("type", newValue ? newValue.key : null, {
                    shouldDirty: true,
                  });
                }}
                isOptionEqualToValue={(option, value) => option == value}
                renderInput={(params) => (
                  <TextField {...params} label="النوع" size="small" />
                )}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="رقم الهاتف"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="imei"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="IMEI"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
      <SectionCard icon={<HiOutlineCog6Tooth />} title="الإعدادات">
        <Grid item xs={12} sm={6}>
          <Controller
            name="port"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="البورت"
                fullWidth
                type="number"
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="code"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="الرمز"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        {/* <Grid item xs={12} md={12}>
          <Controller
            name="balance"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="الرصيد"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid> */}
        <Grid item xs={12} sm={6}>
          <Controller
            name="daily_limit"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="الحد الاعلى اليومي"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_active"
            control={control}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label="تفعيل !"
                onChange={(e) => {
                  setValue("is_active", e.target.checked, {
                    shouldDirty: true,
                  });
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default SimCardForm;
